import styled from 'styled-components';

export const Container = styled.div`
  .metric-icon {
    background: ${(props) => props.theme.$secondary_green};
    color: ${(props) => props.theme.$dark};
    border: 1px solid ${(props) => props.theme.$primary_green_light};
    border-radius: 4px;
    width: 35px;
    height: 35px;
  }

  .metric-text span {
    color: ${(props) => props.theme.$gray600};
    text-transform: uppercase;
    font-size: 12px;
  }
`;
